let infoTogggle = document.querySelector(".google-map__toggle");

if (infoTogggle) {
	let info = document.querySelector(".google-map__info");

	infoTogggle.addEventListener("click", () => {
		infoTogggle.classList.toggle("open");
		info.classList.toggle("open");
	});
}

(function($) {
	/* eslint-disable */
	function initMap($el) {
		var $markers = $el.find(".marker");

		var mapArgs = {
			zoom: 15,
			mapTypeId: google.maps.MapTypeId.ROADMAP,
			styles: [
				{
					featureType: "administrative",
					elementType: "labels.text.fill",
					stylers: [
						{
							color: "#2f2f2f"
						}
					]
				},
				{
					featureType: "landscape",
					elementType: "all",
					stylers: [
						{
							color: "#efefef"
						}
					]
				},
				{
					featureType: "poi",
					elementType: "all",
					stylers: [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "road",
					elementType: "all",
					stylers: [
						{
							saturation: -100
						},
						{
							lightness: 45
						}
					]
				},
				{
					featureType: "road.highway",
					elementType: "all",
					stylers: [
						{
							visibility: "simplified"
						}
					]
				},
				{
					featureType: "road.arterial",
					elementType: "labels.icon",
					stylers: [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "transit",
					elementType: "all",
					stylers: [
						{
							visibility: "off"
						}
					]
				},
				{
					featureType: "water",
					elementType: "all",
					stylers: [
						{
							color: "#dcddde"
						},
						{
							visibility: "on"
						}
					]
				}
			]
		};
		var map = new google.maps.Map($el[0], mapArgs);

		map.markers = [];
		$markers.each(function() {
			initMarker($(this), map);
		});

		centerMap(map);

		return map;
	}

	function initMarker($marker, map) {
		var lat = $marker.data("lat");
		var lng = $marker.data("lng");
		var latLng = {
			lat: parseFloat(lat),
			lng: parseFloat(lng)
		};

		var marker = new google.maps.Marker({
			position: latLng,
			map: map,
			icon: $marker.data("img")
		});

		map.markers.push(marker);

		if ($marker.html()) {
			var infowindow = new google.maps.InfoWindow({
				content: $marker.html()
			});

			google.maps.event.addListener(marker, "click", function() {
				infowindow.open(map, marker);
			});
		}
	}

	function centerMap(map) {
		var bounds = new google.maps.LatLngBounds();
		map.markers.forEach(function(marker) {
			bounds.extend({
				lat: marker.position.lat(),
				lng: marker.position.lng()
			});
		});

		if (map.markers.length == 1) {
			map.setCenter(bounds.getCenter());
		} else {
			map.fitBounds(bounds);
		}
	}

	$(document).ready(function() {
		$(".google-map").each(function() {
			var map = initMap($(this));
		});
	});
	/* eslint-enable */
})(jQuery);



// WEBPACK FOOTER //
// ./scripts/modules/_map.js